import API from '@/api'

export default {
  data() {
    return {
      dashboardData: {
        pieData: {},
        tableData: [],
        tableData2: []
      },
      pieLoading: true,
      dashboardTableLoading: true,
      status: [],
      sourceOfInfo: [],
    }
  },
  async mounted() {
    //默认展示dashboard页面
    if (this.$route.query.openDashboard === '1') {
      this.$refs.dashboard.openDraw();
    }
  },
  methods: {
    // 点击饼图更新state重新查询
    chooseState(data) {
      switch (data.name) {
        case '待提交':
        case 'Initiated':
          this.status = ['1']
          break

        case '已提交给集团项目组':
        case 'Submitted To Group':
          this.status = ['2']
          break

        case '需修订':
        case 'Revision Required':
          this.status = ['3']
          break

        case '集团项目组已审阅':
        case 'Approved By Group Team':
          this.status = ['4']
          break
      }
      this.searchForm.statusList = this.status;
      this.getTableList()
    },
    async getPbcDrawerTableData(viewType) {
      const params = this.queryParams()
      params.viewType = viewType || '0' // 默认0 组成部分
 
      let tableData = []
      let tableData2 = []
      try {
        let { code, data } = await API.exchange.getDashTable(params)
        if (code == '1') {
          if (data.length > 0) {
            data.forEach((item) => {
              item.total = item.initiated + item.submittedToGroup + item.revisionRequired + item.approvedByGroupTeam
            })
            tableData = data.map((v) => {
              if (v.target == 'blank') {
                v.target = this.$t('no_assign')
              }
              return v
            })
            let data2 = []
            data.forEach((item) => {
              let temp = {}
              temp.target = item.target

              temp.initiated = item.total == 0 ? '0%' : Math.round((item.initiated * 100) / item.total) + '%'
              temp.submittedToGroup = item.total == 0 ? '0%' : Math.round((item.submittedToGroup * 100) / item.total) + '%'
              temp.revisionRequired = item.total == 0 ? '0%' : Math.round((item.revisionRequired * 100) / item.total) + '%'
              temp.approvedByGroupTeam = item.total == 0 ? '0%' : Math.round((item.approvedByGroupTeam * 100) / item.total) + '%'

              temp.total = item.total
              data2.push(temp)
            })
            tableData2 = data2
          }

          return { tableData, tableData2 }
        } else {
          this.$message.error(this.$t(code))
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.dashboardTableLoading = false
      }
    },
    // 选择维度表格--更新维度
    async getPbcDrawerTable(viewType) {
      this.dashboardTableLoading = true
      this.dashboardData.tableData = []
      this.dashboardData.tableData2 = []
      const { tableData, tableData2 } = await this.getPbcDrawerTableData(viewType)
      this.dashboardData.tableData = tableData
      this.dashboardData.tableData2 = tableData2
    },
    // 查询图标---饼图信息
    async getPieEcharts() {
      try {
        this.pieLoading = true
        const params = this.queryParams()
        params.lang = this.$i18n.locale
        const { data, code } = await API.exchange.getPieData(params)

        if (code == '1') {
          this.dashboardData.pieData = data
        } else {
          this.$message.error(this.$t(code))
        }
      } catch (e) {
      } finally {
        this.pieLoading = false
      }
    },
  },
}